import React from "react";
import { CalendarDays } from "lucide-react";
import { conflictText, dayKey, formatDay, formatTaughtDay, movedFrom, taughtDayKey } from "./scheduleFormat";

/**
 * SessionDateLine — one syllabus day's date, for the trainer's day card:
 * "Fri, 17 Oct · Overdue · moved from Thu, 15 Oct".
 *
 * Reads `session.schedule` (staff only — GET /syllabus/batch/:id/syllabus) for
 * overdue and holiday flags; without it the plain date still shows.
 */
const SessionDateLine = ({ session }) => {
  const planned = dayKey(session?.plannedDate);
  if (!planned) return null;
  const original = movedFrom(session);
  const taught = session.status === "completed" ? taughtDayKey(session.actualDate) : null;
  const { overdue, conflict } = session.schedule || {};

  return (
    <span className="tw-mt-0.5 tw-flex tw-flex-wrap tw-items-center tw-gap-x-2 tw-gap-y-0.5 tw-text-xs tw-font-medium">
      <span className="tw-inline-flex tw-items-center tw-gap-1 tw-text-content-muted">
        <CalendarDays size={12} aria-hidden="true" />
        {formatDay(planned)}
      </span>
      {overdue && <span className="tw-text-warning-fg">Overdue</span>}
      {conflict && <span className="tw-text-warning-fg">{conflictText(conflict)}</span>}
      {taught && taught !== planned && (
        <span className="tw-text-content-subtle">taught {formatTaughtDay(session.actualDate)}</span>
      )}
      {!taught && original && <span className="tw-text-content-subtle">moved from {formatDay(original)}</span>}
    </span>
  );
};

export default SessionDateLine;
